/* eslint-disable @typescript-eslint/no-unused-vars */
import "./tablestyle.scss";

import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridNoRecords
} from "@progress/kendo-react-grid";
import {  useState } from "react";

import PopOver from "../popover";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as CONSTANTS from '../../utils/CONSTANTS';
import { checkAvailability } from "../../utils/EllowUtils";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { SortDescriptor } from "@progress/kendo-data-query";

const ResourceTable = (props: any) => {
     

  const [loginId , setLoginId ] = useState<any>()
  const [candidateStatus , setCandidateStatus] = useState<number>()
  const navigate = useNavigate()

  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  const getTableValues = () => {
   props.getResourceTables()
   
  }

  const rejected = (data: any) => { 
    setLoginId(data.dataItem.loginId)
    setCandidateStatus(6)    
  }

  const blackListed = (data: any) => { 
    setLoginId(data.dataItem.loginId)
    setCandidateStatus(7)    
  }
   
  const availablityCell = (props: GridCellProps) => {

    let data = {
      availability: props.dataItem.availability, 
      availability_date: props.dataItem.availability_date,
      availability_week: props.dataItem.availability_week,
      contractEndDate: props.dataItem.contractEndDate,
      contractStartDate: props.dataItem.contractStartDate
    }
       
    return (
      <td>
        {checkAvailability(data)}
      </td>
    )
  }

  const redirection = (candidateLoginId: string, profileMetadata: any) => {
    navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 } })
   localStorage.setItem('profile_metadata' , JSON.stringify(profileMetadata))
    
  }


  const viewButton = (props: GridCellProps) => {    
    
    return (
      <td>
        
        <button onClick={() => { navigate('/applyresource');localStorage.setItem('resourceApplyPositions', JSON.stringify(props.dataItem))}} className="applyButton"> Apply to position</button>
        
      </td>
    );
  };

  const submittedToCell = (props: GridCellProps) => {


    let submittedToArray = props.dataItem.providerJobDetails && props.dataItem.providerJobDetails.length > 0 && props.dataItem.providerJobDetails.map((item: any) => {
      return item.split('-')[0]
    })    
    
    if (submittedToArray && submittedToArray.length > 1) {
  
      return (
        <td>
          <div className="positionStstus"><PopOver title="Multiple Position" position="rightBottom">
            {submittedToArray && submittedToArray.map((item: any, key: number) => {
              return (
                <div  key={key} className="positionList">
                  <span className="status warning" />
                  <strong>{item}</strong>                 
                </div>
              )
            })
            }
          </PopOver>
          </div>
        </td>
      )
    }
    else {
      
      return (
        <td>
          <div>
            {submittedToArray &&  submittedToArray.length > 0 && submittedToArray.map((item: any) => {
              return (
                <div className="positionList noPadd">
                  <strong>{item}</strong>
                </div>
              )
            })}
          </div>
  
        </td>
      )
    }
  }

 { console.log('data', props.data)}


  return (
    <>
    <Grid
      data={props.data}
      onPageChange={props.pageChange}
      total={props.state.total}
      skip={props.state.skip}
      pageable={props.state.pageable}
      pageSize={props.state.pageSize}
      onItemChange={props.itemChange}
    //  onRowClick={(e) => rowClick(e)}
      onSortChange={(e) => {
       setSort(e.sort);
       props.setSort(e.sort);
       props.applySort(e.sort);

        }}
      sortable={true}
      sort={sort}
    >
      <GridNoRecords>
        <div className="noData">
          <Icon icon="mdi:smiley-neutral-outline" />
          No data to display
        </div>
      </GridNoRecords>
      <Column field="name" title="Full name" width="180" className="noWordWrap" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId, props.dataItem))} />
      <Column field="experience" title="Experience" cell={experienceCell} />
      <Column field="Skills" title="Core skills" cell={skillsCell} />
      <Column field="availability" title="Availability" cell={availablityCell} />
      <Column field="submittedTo" title="Submitted to" cell={submittedToCell}/>
      {!props.hideStatus && <Column field="ellowStatus" title="ellow status" cell={(props: GridCellProps) => ellowStatusDropdown(props, () => getTableValues(), () => rejected(props), () => blackListed(props))} />}
      <Column
        field="dateOfRegistration"
        title="Date of Registration"
        cell={dateCell}
      />
      <Column field="allocatedTo" title="Allocated To"  />
      <Column cell={viewButton}  width="70px" />

      </Grid>
     
      </>
  );
};

export default ResourceTable;


const dateCell = (props: GridCellProps) => {
  let dateNumber = parseInt(props.dataItem.dateOfRegistration);
  let date = new Date(dateNumber).toDateString();

  return <td><div className="dateWrap">{date}</div></td>;
};

const experienceCell = (props: GridCellProps) => {
  if(props.dataItem.experience !== null){
    return <td>{props.dataItem.experience + " Years"}</td>;
  }else{
    return <td>{"Not Mentioned"}</td>;
  }
};


const skillsCell = (props: GridCellProps) => {

  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
       <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number)  => {
           return ((item) +  (key < length-1 ?     ' , ' : ''))          })}
      </div>
    </td>
  );
};


const nameCell = (props: GridCellProps, redirection: any) => {

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.dateOfRegistration
  var diff =(currentDate -  dateOfRegistration) / 1000;
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff));
  
  const profileImage = props.dataItem.googleProfileImage ?  props.dataItem.googleProfileImage : " " 
  
  return (
    <td  className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" onClick={() => redirection(props.dataItem.loginId, props.dataItem)}>
          {profileImage === " "? 
           <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img alt="" src={ profileImage }></img></figure> 
          }
          <div>
          {props.dataItem.name}
          <div className="email">{props.dataItem.email}</div>
          <div className="phone">{props.dataItem.phoneNumber}</div>
          </div>
      </div>
    </td>
  )
}

const ellowStatusDropdown = (props: GridCellProps, getTableValues: any , rejected: any , blackListed: any) => {
    
  const { dataItem } = props;
  const field = props.field || '';
  
  const dataValue = dataItem[field] === null ? '' : dataItem[field];




  return (
    <td>
      { dataItem && dataItem.inEdit ? (
        <DropDownList
          style={{ width: "100%" }}
          data={CONSTANTS.candidateStatus}
       
          dataItemKey='id'
          textField="name"
        />
    ) :(dataValue)  }
    </td>
  )
}

